/**
 * "Übersicht der Vertretungsanfragen" (office): what is going on with an inquiry and where it is listed.
 * Copy of shrd utils/enums/substitution-manager/SubstitutionOverview.ts. Computed by the substitution-manager (src/overview/overview.rules.ts) for the list, the counter tiles and the filter
 * `situation`; the frontend has a copy (helpers/substitutions/overview.ts).
 */
export enum SubstitutionOverviewSituation {
    /** Created by the office, request not sent yet ("Prüfen und senden") */
    NOT_SENT = 'notSent',
    /** Sick report in mode "Nur melden": reported, nobody searches yet, no automatic cancellation */
    REPORTED_ONLY = 'reportedOnly',
    /** Nobody could be asked (placeholder of a sick report or no substitute in the inquiry) */
    NO_CANDIDATES = 'noCandidates',
    /** Everybody asked said "Kann ich nicht" */
    ALL_DECLINED = 'allDeclined',
    /** The confirmed substitute withdrew, nobody is open any more */
    WITHDRAWN = 'withdrawn',
    /** Somebody confirmed, but nobody is selected as substitute yet */
    CHOOSE = 'choose',
    /** Cancellation saved with "Prüfen vor dem Senden", messages not sent yet */
    CANCEL_NOT_SENT = 'cancelNotSent',
    /** Request sent, answers open */
    SEARCHING = 'searching',
    /** A substitute is selected */
    FOUND = 'found',
    /** Cancelled, compensation not decided yet */
    COMPENSATION_OPEN = 'compensationOpen',
    /** Cancellation is being sent */
    CANCELLING = 'cancelling',
    /** Cancelled, compensation decided */
    CANCELLED = 'cancelled',
    /** Day is over without substitute and without cancellation (older backends; now FOLLOW_UP_OPEN / FOLLOW_UP_DONE) */
    PAST = 'past',
    /** "Nachbereitung offen": day over without selected substitute and without completed cancellation, not finished */
    FOLLOW_UP_OPEN = 'followUpOpen',
    /** Like FOLLOW_UP_OPEN, but the office finished the Nachbereitung ("Nachbereitet") */
    FOLLOW_UP_DONE = 'followUpDone',
}

/** Sections of the list, in this order */
export enum SubstitutionOverviewGroup {
    /** "Handeln nötig" */
    ACTION = 'action',
    /** "Suche läuft" */
    SEARCHING = 'searching',
    /** "Vertretung steht" */
    FOUND = 'found',
    /** "Nachbereitung offen" */
    FOLLOW_UP = 'followUp',
    /** "Abgesagt · Kompensation offen" */
    COMPENSATION = 'compensation',
    /** "Erledigt" (cancelled, past) – collapsed */
    DONE = 'done',
}

export const SUBSTITUTION_OVERVIEW_GROUP_ORDER: SubstitutionOverviewGroup[] = [
    SubstitutionOverviewGroup.ACTION,
    SubstitutionOverviewGroup.SEARCHING,
    SubstitutionOverviewGroup.FOUND,
    SubstitutionOverviewGroup.FOLLOW_UP,
    SubstitutionOverviewGroup.COMPENSATION,
    SubstitutionOverviewGroup.DONE,
];

export const SUBSTITUTION_OVERVIEW_GROUP_OF: Record<SubstitutionOverviewSituation, SubstitutionOverviewGroup> = {
    [SubstitutionOverviewSituation.NOT_SENT]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.REPORTED_ONLY]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.NO_CANDIDATES]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.ALL_DECLINED]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.WITHDRAWN]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.CHOOSE]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.CANCEL_NOT_SENT]: SubstitutionOverviewGroup.ACTION,
    [SubstitutionOverviewSituation.SEARCHING]: SubstitutionOverviewGroup.SEARCHING,
    [SubstitutionOverviewSituation.FOUND]: SubstitutionOverviewGroup.FOUND,
    [SubstitutionOverviewSituation.COMPENSATION_OPEN]: SubstitutionOverviewGroup.COMPENSATION,
    [SubstitutionOverviewSituation.CANCELLING]: SubstitutionOverviewGroup.DONE,
    [SubstitutionOverviewSituation.CANCELLED]: SubstitutionOverviewGroup.DONE,
    [SubstitutionOverviewSituation.PAST]: SubstitutionOverviewGroup.DONE,
    [SubstitutionOverviewSituation.FOLLOW_UP_OPEN]: SubstitutionOverviewGroup.FOLLOW_UP,
    [SubstitutionOverviewSituation.FOLLOW_UP_DONE]: SubstitutionOverviewGroup.DONE,
};
